import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/shared/services';

@Injectable({
  providedIn: 'root',
})
export class QuotationCustomerService {
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiUrl = this.configService.getConfig()['apiURL']; // e.g., 'http://localhost:1337/api'
  }

  getCustomers(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}quotation-customers`);
  }

  createCustomer(customer: any): Observable<any> {
    return this.http.post(`${this.apiUrl}quotation-customers`, customer);
  }

  updateCustomer(uuid: string, customer: any): Observable<any> {
    return this.http.put(`${this.apiUrl}quotation-customers/${uuid}`, customer);
  }

  deleteCustomer(uuid: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}quotation-customers/${uuid}`);
  }
  getCustomerByUuid(uuid: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}quotation-customers/${uuid}`);
  }
}